import { isEmpty } from '@adex/shared/utils/data'


export function patchState<S, K extends keyof S>(state: S, key: K, value: Partial<S[K]>): S {
  const lastState = state[key] || {}
  return {
    ...state,
    [key]: isEmpty(value) ? value : { ...lastState, ...value }
  }
}
